var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiDrivenAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3911_354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5385 2.49609C11.2695 2.49609 9.39741 4.19041 9.1151 6.38269C9.1023 6.38262 9.08979 6.3817 9.07699 6.3817C6.61296 6.3817 4.61545 8.37921 4.61545 10.8432V12.5918C2.64888 12.5917 1.05469 14.1859 1.05469 16.1525V19.8492C1.05469 21.8158 2.64888 23.41 4.61545 23.41V25.1585C4.61545 27.6225 6.61296 29.6201 9.07699 29.6201C9.08979 29.6201 9.10237 29.6192 9.1151 29.6191C9.39734 31.8113 11.2694 33.5057 13.5385 33.5057C16.0026 33.5057 18 31.5082 18 29.0441V6.95756C18 4.49353 16.0025 2.49609 13.5385 2.49609Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61548 12.5898V14.001C4.61548 16.0054 6.24033 17.6303 8.24473 17.6303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4459 10.176C9.60111 9.36408 9.07532 8.22263 9.07532 6.95841C9.07532 4.49395 11.0732 2.49609 13.5376 2.49609",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4459 25.8242C9.60111 26.6362 9.07532 27.7776 9.07532 29.0419C9.07532 31.5063 11.0732 33.5042 13.5376 33.5042",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8359 20.1094C34.0009 20.1094 34.9453 19.165 34.9453 18C34.9453 16.835 34.0009 15.8906 32.8359 15.8906C31.671 15.8906 30.7266 16.835 30.7266 18C30.7266 19.165 31.671 20.1094 32.8359 20.1094Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7266 18H18",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6882 5.27344C24.8532 5.27344 25.7976 4.32904 25.7976 3.16406C25.7976 1.99909 24.8532 1.05469 23.6882 1.05469C22.5233 1.05469 21.5789 1.99909 21.5789 3.16406C21.5789 4.32904 22.5233 5.27344 23.6882 5.27344Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6882 5.23438V8.11346L18 9.51549",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.953 12.1172C31.118 12.1172 32.0624 11.1728 32.0624 10.0078C32.0624 8.84284 31.118 7.89844 29.953 7.89844C28.788 7.89844 27.8436 8.84284 27.8436 10.0078C27.8436 11.1728 28.788 12.1172 29.953 12.1172Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4889 11.4727L26.4531 13.5085H18",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6882 34.9453C24.8532 34.9453 25.7976 34.0009 25.7976 32.8359C25.7976 31.671 24.8532 30.7266 23.6882 30.7266C22.5233 30.7266 21.5789 31.671 21.5789 32.8359C21.5789 34.0009 22.5233 34.9453 23.6882 34.9453Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6882 30.7655V27.8864L18 26.4844",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.953 28.1016C31.118 28.1016 32.0624 27.1572 32.0624 25.9922C32.0624 24.8272 31.118 23.8828 29.953 23.8828C28.788 23.8828 27.8436 24.8272 27.8436 25.9922C27.8436 27.1572 28.788 28.1016 29.953 28.1016Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4889 24.528L26.4531 22.4922H18",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3911_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDrivenAnalytics);
export default __webpack_public_path__ + "static/media/ai-driven-analytics.02463e35fab6fd72ece8a9b210b401cb.svg";
export { ForwardRef as ReactComponent };